// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_23j1vZgE2ozTOtkywrcQtx","drag":"_1Rs8-8q5SUCCTZhrS6K2S5","edit":"_1tEyqC2wLKXG144_C1cPDW"};